module.exports = __webpack_public_path__ + "static/media/DSCF1450-2.476a156e.jpg";